<template>
  <div
    v-resizable="direction"
    class="layout-container resizable-container"
    :style="{
      height: handleHeight,
      'flex-direction': direction === 'horizontal' ? 'row' : 'column',
    }"
  >
    <div
      :class="['content', 'flexV', { 'wrapper': styleSt.flex }]"
      :style="styleSt"
      :weight="styleSt.flex"
    >
      <p v-if="titleSt" class="title">{{ titleSt }}</p>
      <div
        class="h100 overflow-scroll"
        :style="contentStyleSt"
        :class="contentClassSt"
      >
        <slot :name="direction === 'horizontal' ? 'leftContent' : 'topContent'" />
      </div>
    </div>
    <div
      :class="['content', 'flexV', { 'wrapper': styleNd.flex }]"
      :style="styleNd"
      :weight="styleNd.flex"
    >
      <div v-if="titleNd" class="title">{{ titleNd }}</div>
      <div
        class="h100 overflow-scroll"
        :style="contentStyleNd"
        :class="contentClassNd"
      >
        <slot :name="direction === 'horizontal' ? 'rightContent' : 'bottomContent'"/>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../lib/styles/components/Layout.scss'
export default {
  name: 'Layout',
  props: {
    height: {
      type: [String, Number],
      default: 'auto'
    },
    // 间距
    gutter: {
      type: Number,
      default: 0
    },
    // 布局方向：horizontal/vertical
    direction: {
      type: String,
      default: 'horizontal'
    },
    // 左边 content的百分比
    leftWidth: {
      type: String,
      default: '30%'
    },
    // 右边 content的百分比(默认铺满剩下空间)
    rightWidth: {
      type: String,
      default: ''
    },
    // 上边 content的百分比
    topHeight: {
      type: String,
      default: '30%'
    },
    // 下边 content的百分比(默认铺满剩下空间)
    bottomHeight: {
      type: String,
      default: ''
    },
    // 左边标题
    leftTitle: {
      type: String,
      default: ''
    },
    // 上边标题
    topTitle: {
      type: String,
      default: ''
    },
    // 右边标题
    rightTitle: {
      type: String,
      default: ''
    },
    // 下边标题
    bottomTitle: {
      type: String,
      default: ''
    },
    // 左边背景色
    leftBgColor: {
      type: String,
      default: ''
    },
    // 上边背景色
    topBgColor: {
      type: String,
      default: ''
    },
    // 右边背景色
    rightBgColor: {
      type: String,
      default: ''
    },
    // 下边背景色
    bottomBgColor: {
      type: String,
      default: ''
    },
    // 左边border
    leftBorder: {
      type: Boolean,
      default: false
    },
    // 上边border
    topBorder: {
      type: Boolean,
      default: false
    },
    topLeftBorder: {
      type: Boolean,
      default: false
    },
    topRightBorder: {
      type: Boolean,
      default: false
    },
    // 右边border
    rightBorder: {
      type: Boolean,
      default: false
    },
    // 下边border
    bottomBorder: {
      type: Boolean,
      default: false
    },
    leftPadding: {
      type: String,
      default: '0px'
    },
    rightPadding: {
      type: String,
      default: '0px'
    },
    topPadding: {
      type: String,
      default: '0px'
    },
    bottomPadding: {
      type: String,
      default: '0px'
    }
  },
  computed: {
    // 左标题、上标题
    titleSt() {
      switch (this.direction) {
        case 'horizontal':
          return this.leftTitle
        case 'vertical':
          return this.topTitle
        default:
          return ''
      }
    },
    // 右标题、下标题
    titleNd() {
      switch (this.direction) {
        case 'horizontal':
          return this.rightTitle
        case 'vertical':
          return this.bottomTitle
        default:
          return ''
      }
    },
    styleSt() {
      const style = this.firstProportion
      style['background'] = this.functionSt('BgColor')
      if (this.gutter) {
        switch (this.direction) {
          case 'horizontal':
            style['margin-right'] = `${this.gutter / 2}px`
            break
          case 'vertical':
            style['margin-bottom'] = `${this.gutter / 2}px`
            break
          default:
            return false
        }
      }
      return style
    },
    styleNd() {
      const style = this.secondProportion
      style['background'] = this.functionNd('BgColor')
      if (this.gutter) {
        switch (this.direction) {
          case 'horizontal':
            style['margin-left'] = `${this.gutter / 2}px`
            break
          case 'vertical':
            style['margin-top'] = `${this.gutter / 2}px`
            break
          default:
            return false
        }
      }
      return style
    },
    contentStyleSt() {
      const padding = this.functionSt('Padding')
      return { 'padding': padding }
    },
    contentStyleNd() {
      const padding = this.functionNd('Padding')
      return { 'padding': padding }
    },
    contentClassSt() {
      const result = {
        left: this.direction === 'horizontal',
        top: this.direction === 'vertical'
      }
      // 水平模式下 若同时拥有左右边框 则去掉容器左的右边框和容器右的右边框
      result['no-border-right'] =
        this.leftBorder && this.rightBorder && this.direction === 'horizontal'
      // 垂直模式下 若同时存在上下边框 则去掉容器上的下边框和容器下的上边框
      result['no-border-bottom'] =
        this.topBorder && this.bottomBorder && this.direction !== 'horizontal'
      const r = { ...this.hanlderBorderProps }
      // 合并边框class
      Object.assign(result, r)
      if (this.rightBorder && this.direction === 'horizontal') {
        if (this.leftBorder) {
          // 同时有左右，保留一侧
          result['border-right'] = true
          result['no-border-right'] = false
        } else {
          result['border-right'] = false
        }
      }
      if (this.bottomBorder && this.direction !== 'horizontal') {
        result['border-bottom'] = false
      }
      // 水平模式下 左侧容器顶部线
      if (
        !this.topBorder &&
        this.direction === 'horizontal' &&
        this.topLeftBorder
      ) {
        result['border-top'] = true
      }
      return result
    },
    contentClassNd() {
      const result = {}
      // 水平模式下 若同时拥有左右边框 则去掉容器左的右边框和容器右的右边框
      result['no-border-left'] =
        this.leftBorder && this.rightBorder && this.direction === 'horizontal'
      // 垂直模式下 若同时存在上下边框 则去掉容器上的下边框和容器下的上边框
      result['no-border-top'] =
        this.topBorder && this.bottomBorder && this.direction !== 'horizontal'
      // 合并边框class
      const r = { ...this.hanlderBorderProps }
      Object.assign(result, r)
      if (this.leftBorder && this.direction === 'horizontal') {
        result['border-left'] = false
      }
      if (this.topBorder && this.direction !== 'horizontal') {
        result['border-top'] = false
      }
      // 水平模式下 右侧容器顶部线
      if (
        !this.topBorder &&
        this.direction === 'horizontal' &&
        this.topRightBorder
      ) {
        result['border-top'] = true
      }

      return result
    },
    firstProportion() {
      if (this.direction === 'horizontal') {
        return this.judgeFirstStyle(this.leftWidth, this.rightWidth)
      } else if (this.direction === 'vertical') {
        return this.judgeFirstStyle(this.topHeight, this.bottomHeight)
      }
      return ''
    },
    secondProportion() {
      if (this.direction === 'horizontal') {
        return this.judgeSecondStyle(this.rightWidth, this.leftWidth)
      } else if (this.direction === 'vertical') {
        return this.judgeSecondStyle(this.bottomHeight, this.topHeight)
      }
      return ''
    },
    hanlderBorderProps() {
      const o = {}
      o['border-top'] = this.topBorder
      o['border-left'] = this.leftBorder
      o['border-right'] = this.rightBorder
      o['border-bottom'] = this.bottomBorder
      return o
    },
    handleHeight() {
      const type = typeof this.height
      if (type === 'string') {
        return this.height
      } else if (type === 'number') {
        return this.height + 'px'
      }
      return this.height
    }
  },
  methods: {
    // BgColor、Padding、Title
    functionSt(v) {
      switch (this.direction) {
        case 'horizontal':
          return this['left' + v]
        case 'vertical':
          return this['top' + v]
        default:
          return false
      }
    },
    // BgColor、Padding、Title
    functionNd(v) {
      switch (this.direction) {
        case 'horizontal':
          return this['right' + v]
        case 'vertical':
          return this['bottom' + v]
        default:
          return false
      }
    },
    handleResize(weight) {
      this.$emit('handleResize', weight)
    },
    // 百分比转小数
    toDecimal(percent) {
      let str = percent.replace('%', '')
      str = str / 100
      return str
    },
    // 字符串是否包含px、rem、em等字母
    includeWord(str) {
      const reg = /[A-Za-z]/
      return reg.test(str)
    },
    // 判断左/上宽/高度样式值
    judgeFirstStyle(value1, value2) {
      if (this.includeWord(value1)) {
        return { width: value1 }
      }
      if (this.includeWord(value2)) {
        return { flex: 1 }
      }
      return { flex: this.toDecimal(value1) }
    },
    // 判断右/下宽/高度样式值
    judgeSecondStyle(value1, value2) {
      if (value1) {
        if (this.includeWord(value1)) {
          return { width: value1 }
        }
        if (this.includeWord(value2)) {
          return { flex: 1 }
        }
        return { flex: this.toDecimal(value1) }
      } else {
        if (this.includeWord(value2)) {
          return { flex: 1 }
        }
        return { flex: 1 - this.toDecimal(value2) }
      }
    }
  }
}
</script>
